module.exports = __webpack_public_path__ + "img/c1-10.efbc3fb3.png";